module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ql-app"
    }
  }, [_c('core-header', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user,
      "locked": _vm.isLocked
    }
  }), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "sub-header",
    attrs: {
      "md-flex": "100",
      "md-row": "",
      "md-gutter": "12"
    }
  }, [_c('project-header', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalPages": _vm.totalPages,
      "locked": _vm.isLocked,
      "showMode": _vm.showMode,
      "isOwner": _vm.user.uid === _vm.project.ownerUID,
      "isActivePay": _vm.user.active_pay
    },
    on: {
      "pageUp": _vm.pageUp,
      "pageDown": _vm.pageDown,
      "setPage": _vm.setCurrentPage,
      "toggleShowMode": _vm.toggleShowMode,
      "toggleLocked": _vm.toggleLocked
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "page-viewer"
  }, [_c('project-pages', {
    attrs: {
      "pages": _vm.projectPages,
      "currentPage": _vm.currentPage,
      "currentUser": _vm.user,
      "locked": _vm.isLocked,
      "showMode": _vm.showMode
    }
  })], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ae9ed0f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/views/project.vue
// module id = 659
// module chunks = 2